import { env } from '@/env'
import { ModuleBase } from "@/modules/base"
import { V3 } from '@/utils/math'
import { queryParams } from '@/utils/query_params'
import { routerSync } from '@/vue/router'
import { Component, Mixins, Vue, Watch } from 'vue-property-decorator'
import BaseLayer from "./BaseLayer.vue"
import DatasetMenu from "./DatasetMenu.vue"
import Menu from './Menu.vue'
import OverlayLayer from './OverlayLayer.vue'
import ParamsWindow from './ParamsWindow/index.vue'

@Component
export class SspDataModule extends Mixins(ModuleBase) {
  showParamsWindow = !queryParams.jupyter

  frameStore() {
    @Component
    class FrameStore extends Vue {
      showSurface = true
      showFrame = true
      showFieldName = true

      params = defaultParams()
      activeReruns = env.defaultActiveReruns

      get activeRerunsOrdered() {
        const reruns: string[] = []
        for (const r of env.releases) {
          reruns.push(...r.reruns)
        }
        return reruns.filter((r) => this.activeReruns.indexOf(r) >= 0)
      }

      @Watch('params', { deep: true })
      onParamsChange() {
        routerSync()
      }

      @Watch('activeReruns')
      onActiveRerunsChange() {
        routerSync()
      }
    }

    return new FrameStore()
  }

  get outlet() {
    return {
      baseLayer: BaseLayer,
      overlayLayer: OverlayLayer,
      window: ParamsWindow,
      analysisMenu: Menu,
      datasetMenu: DatasetMenu,
    }
  }
}

export function defaultParams() {
  return {
    type: MixerType.SDSS_TRUE_COLOR,
    filter: ['HSC-I', 'HSC-R', 'HSC-G'],
    simpleRgb: {
      beta: Math.exp(10),
      a: 1,
      bias: 0.05,
      b0: 0,
    },
    sdssTrueColor: {
      beta: Math.exp(10),
      a: 1,
      bias: 0.05,
      b0: 0,
    },
    simpleColorMatrix: {
      colors: env.filters.map(f => ({
        filterName: f.value,
        enabled: ['HSC-I', 'HSC-R', 'HSC-G'].includes(f.value),
        value: (({ 'HSC-I': [1, 0, 0], 'HSC-R': [0, 1, 0], 'HSC-G': [0, 0, 1] } as any)[f.value] || [0, 0, 0]) as V3,
      })),
      beta: Math.exp(10),
      a: 1,
      bias: 0.05,
      b0: 0,
    },
  }
}

export enum MixerType {
  SIMPLE_RGB = 'SIMPLE_RGB',
  SDSS_TRUE_COLOR = 'SDSS_TRUE_COLOR',
  SIMPLE_COLOR_MATRIX = 'SIMPLE_COLOR_MATRIX',
}

export type Params = ReturnType<typeof defaultParams>
